// CU-86d45b2z1 — navigation-only mirrors of the server's customer-directory predicate (is_customer, user_type=customer,
// Shopify link; never customer_advanced). The commerce customer_directory_member claim is the authorisation boundary.
import { getSessionUser } from "../auth/sessionUser";
import type { User } from "../../types/admin/UserTypes";

export type CustomerDirectoryFields = Pick<User, "is_customer" | "user_type" | "shopify_customer_id">;

export const CUSTOMER_ROUTE_ROOT = "/customer";

const readSessionUser = (): Partial<User> => {
	try {
		return getSessionUser();
	} catch {
		return {};
	}
};

const hasShopifyLink = (user: Partial<CustomerDirectoryFields>): boolean =>
	user.shopify_customer_id !== null &&
	user.shopify_customer_id !== undefined &&
	String(user.shopify_customer_id) !== "";

export const isCustomerDirectoryMember = (user: Partial<CustomerDirectoryFields> | null | undefined): boolean =>
	!!user && (user.is_customer === true || user.user_type === "customer" || hasShopifyLink(user));

export const isCustomerIdentity = (user?: Partial<Pick<User, "user_type">> | null): boolean =>
	(user ?? readSessionUser()).user_type === "customer";

export const isCustomerRoute = (pathname: string): boolean =>
	pathname === CUSTOMER_ROUTE_ROOT || pathname.startsWith(`${CUSTOMER_ROUTE_ROOT}/`);
